import React from "react";

import classnames from "classnames";

import { BodyMedium } from "Cobalt/BodyText";
import type { RadioProps, RadioGroupProps } from "Theme/RadioGroup";

import makeBem from "Utils/makeBem";

const bem = makeBem("CommonRadioGroup");
export const Radio = ({ name, onChange, value, checked, children, inline, disabled = false }: RadioProps) => {
  const inputId = `radio-${name}-${value}`;

  const handleClick = () => {
    if (!disabled) {
      if (onChange) {
        onChange(value);
      } else {
        console.warn("Radio: onChange is required");
      }
    }
  };

  return (
    <BodyMedium className={classnames(bem("option"), inline && bem("option", "inline"))} onClick={handleClick}>
      <input
        id={inputId}
        type="radio"
        name={name}
        value={value}
        disabled={disabled}
        checked={checked} // Provide a noop handler to suppress react warnings about readonly fields
        onClick={() => undefined}
        onChange={() => undefined}
      />
      {false && <div className={bem("bead")} />}
      <label htmlFor={inputId}>{children}</label>
    </BodyMedium>
  );
};
export const RadioGroup = ({ disabled = false, inline, options, id, name, value, onChange, ...rest }: RadioGroupProps) => {
  const mappedOptions = Array.isArray(options) ? options : Object.entries(options);
  return (
    <>
      {mappedOptions.map(([optionValue, label], i) => (
        <Radio {...rest} key={i} name={name} onChange={onChange} inline={inline} value={optionValue} checked={value === optionValue} disabled={disabled}>
          {label}
        </Radio>
      ))}
    </>
  );
};
